/* eslint-disable no-redeclare */
import type { z } from 'zod';

import { NonEmptyText } from './non-empty-text';

export const CountyFips = NonEmptyText;

export type CountyFips = z.infer<typeof CountyFips>;
